/* eslint-disable no-console */
/* START GENAI@GHCOPILOT */
import LogRocket from 'logrocket';

export const shouldLog = document.cookie.indexOf('DEBUG=true') > -1 || false;
let recordingURL;
let collectHeaders = true;
let collectPayload = true;
let correlationId = '';
let srcInitData: SrcInitData = {
  dpaId: 'UNAVAILABLE',
  dpaName: 'UNAVAILABLE',
  srcInitiatorId: 'UNAVAILABLE',
  srcTransactionId: 'UNAVAILABLE'
};

/* START GENAI@GHCOPILOT */
const sensitive = [
  'access_token',
  'activity_ref',
  'authorization',
  'consumerIdentity',
  'encryptedCard',
  'encryptedConsumer',
  'ermEnabled',
  'idToken',
  'remember_me',
  'set-cookie',
  'v-c-vaap-token'
];

type SrcInitData = {
  correlationId?: string;
  dpaId?: string;
  dpaName?: string;
  srcInitiatorId?: string;
  srcTransactionId?: string;
};
type JSONUnknown = { [key: string]: unknown };

// START GENAI@GHCOPILOT
export const setCollectHeaders = (collect: boolean) => {
  shouldLog && console.log(`[LR] Setting collectHeaders to ${collect}`);
  collectHeaders = collect;
};

export const setCollectPayload = (collect: boolean) => {
  shouldLog && console.log(`[LR] Setting collectPayload to ${collect}`);
  collectPayload = collect;
};

export const setCorrelationId = (CR: string, origin?: string) => {
  shouldLog && console.log(`[LR] Setting CR to ${CR}${origin ? ` for ${origin}` : ''}`);
  correlationId = CR;
};

export const setSrcInitDataForLogrocket = (initData: SrcInitData) => {
  shouldLog &&
    console.log(`[LR] Setting srcInitData to ${JSON.stringify(initData)} :: CR: ${correlationId}`);

  srcInitData = { ...srcInitData, ...initData };
  LogRocket.identify(correlationId, srcInitData);
};
// END GENAI@GHCOPILOT

// START GENAI@GHCOPILOT
const isJsonPayload = (body: unknown): boolean => {
  if (typeof body === 'object' && body !== null) {
    return true;
  }

  return false;
};

const isValidStringifiedJson = (body: string): boolean => {
  try {
    JSON.parse(body);
    return true;
  } catch (e) {
    shouldLog && console.warn(`[LR] Error parsing JSON: ${e}`); // eslint-disable-line no-console
    return false;
  }
};
// END GENAI@GHCOPILOT

// START GENAI@GHCOPILOT
const isHashObject = (value: unknown) => {
  return (
    typeof value === 'object' &&
    value !== null &&
    Object.prototype.toString.call(value) === '[object Object]'
  );
};

// END GENAI@GHCOPILOT
const removeTokensFromHash = (hash: JSONUnknown) => {
  const tokenRegex = /token/gim;
  const tokenKeys = Object.keys(hash).filter(key => key.match(tokenRegex));
  const removeKeys = tokenKeys.concat(sensitive);

  removeKeys.forEach(key => {
    if (hash[key] !== undefined) {
      hash[key] = 'REDACTED'; // TS string | undefined
    }
  });

  // START GENAI@GHCOPILOT
  tokenKeys.forEach(key => {
    if (hash[key] && isHashObject(hash[key])) {
      hash[key] = removeTokensFromHash(hash[key] as JSONUnknown);
    }
  });

  return hash;
};
/* END GENAI@GHCOPILOT */

/* START GENAI@GHCOPILOT */
const cleanCookiesForLR = (cookieString: string) => {
  // turn cookieString string into hash
  let acc: JSONUnknown = {};
  cookieString.split(';').forEach(cookie => {
    // eslint-disable-next-line prefer-const
    let [key, value] = cookie.split('=');
    key = String(key).trim();
    acc[key] = value;
    return acc;
  });

  acc = removeTokensFromHash(acc);

  // turn hash back into string
  return Object.keys(acc)
    .map(key => `${key}=${acc[key]}`)
    .join('; ');
};
/* END GENAI@GHCOPILOT */

/* START GENAI@GHCOPILOT */
// @ts-ignore
const requestSanitizer = (request: IRequest) => {
  // START GENAI@GHCOPILOT
  if (collectHeaders) {
    // remove any tokens from the request headers
    request.headers = removeTokensFromHash(request.headers);

    // Remove sensitive data from requests
    sensitive.forEach(key => {
      if (request.headers[key] !== undefined) {
        request.headers[key] = 'REDACTED';
      }
    });

    // Remove sensitive data from cookies
    if (request.headers.cookie !== undefined) {
      request.headers.cookie = cleanCookiesForLR(request.headers.cookie);
    }
  } else {
    request.headers = null;
    shouldLog && console.log('[LR] FT OFF: request headers are null');
  }

  if (collectPayload) {
    /* START GENAI@GHCOPILOT */
    // payloads
    if (request.body) {
      if (isValidStringifiedJson(request.body)) {
        let body = JSON.parse(request.body);
        body = removeTokensFromHash(body);
        sensitive.forEach(key => {
          if (body[key] !== undefined) {
            body[key] = 'REDACTED';
          }
        });

        request.body = JSON.stringify(body);
      } else {
        console.error('[LR] Request body is not stringified JSON');
      }
    }
    /* END GENAI@GHCOPILOT */
  } else {
    request.body = null;
    shouldLog && console.log('[LR] FT OFF: request body is null');
  }
  // END GENAI@GHCOPILOT

  return request;
};
/* END GENAI@GHCOPILOT */

/* START GENAI@GHCOPILOT */
// @ts-ignore
const responseSanitizer = (response: IResponse) => {
  // START GENAI@GHCOPILOT
  if (collectHeaders) {
    /* START GENAI@GHCOPILOT */
    // remove any tokens from the response headers
    response.headers = removeTokensFromHash(response.headers);

    // Remove sensitive data from response body
    sensitive.forEach(key => {
      if (response.headers[key] !== undefined) {
        response.headers[key] = 'REDACTED';
      }
    });
  } else {
    response.headers = null;
    shouldLog && console.log('[LR] FT OFF: response headers are null');
  }

  if (collectPayload) {
    // Remove sensitive data from response payload
    if (response.body) {
      try {
        if (isValidStringifiedJson(response.body)) {
          const body = JSON.parse(response.body);

          if (isJsonPayload(body)) {
            response.body = removeTokensFromHash(body);
            sensitive.forEach(key => {
              if (body[key] !== undefined) {
                body[key] = 'REDACTED';
              }
            });
          } else {
            console.log('[LR] Response body is not JSON');
          }
        } else {
          console.log('[LR] Response body is not stringified JSON');
        }
      } catch (ex) {
        console.error('[LR] Error parsing response body', ex);
      }
    }
    /* END GENAI@GHCOPILOT */
  } else {
    response.body = null;
    shouldLog && console.log('[LR] FT OFF: response body is null');
  }
  // END GENAI@GHCOPILOT

  return response;
};

export const lrURI = recordingURL;
export const initLogRocket = (origin: string) => {
  if (correlationId === '') {
    // look for CR in the window
    const cr = window.VISA_SDK.correlationId;

    if (cr) {
      setCorrelationId(cr);
    }
  }

  // START GENAI@GHCOPILOT
  if (correlationId) {
    console.log(
      `[LR] -------- initializing LR @${origin} with CR: ${correlationId} for ORIGIN: ${origin}`
    );

    shouldLog && console.log(`[LR] -------- collectHeaders: ${collectHeaders}`);
    shouldLog && console.log(`[LR] -------- collectPayload: ${collectPayload}`);
    shouldLog && console.log(`[LR] -------- srcInitData: ${JSON.stringify(srcInitData)}`);

    LogRocket.init('0png48/click-to-pay', {
      /* START GENAI@GHCOPILOT */
      console: {
        isEnabled: true,
        shouldAggregateConsoleErrors: true
      },
      mergeIframes: false, // sdk in merchant/PSP domain, communicator in visa.com domain
      network: {
        requestSanitizer,
        responseSanitizer
      },
      release: '1.0.0',
      shouldDebugLog: false
      /* END GENAI@GHCOPILOT */
    });

    // LogRocket.getSessionURL((sessionURL: string) => {
    //   recordingURL = sessionURL;
    // });

    /* START GENAI@GHCOPILOT */
    // eslint-disable-next-line no-console
    LogRocket.identify(correlationId, srcInitData);
  } else {
    console.warn(`[LR] -------- correlationId not set, skipping LR init for ${origin}`);
  }
  /* END GENAI@GHCOPILOT */
};
/* END GENAI@GHCOPILOT */
